import * as React from "react";

import {
  FORM_CONTROL_DISABLED_CLASS,
  FORM_CONTROL_FOCUS_RING_CLASS,
  FORM_CONTROL_INVALID_CLASS,
  FORM_CONTROL_PLACEHOLDER_CLASS,
  FORM_CONTROL_SURFACE_CLASS,
  FORM_CONTROL_TEXT_CLASS,
  FORM_CONTROL_VALUE_CLASS,
} from "@/components/ui/form-control";
import { cn } from "@/lib/utils";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        FORM_CONTROL_SURFACE_CLASS,
        "flex min-h-[80px] w-full rounded-md px-3 py-2 transition-colors-smooth",
        FORM_CONTROL_PLACEHOLDER_CLASS,
        FORM_CONTROL_DISABLED_CLASS,
        FORM_CONTROL_FOCUS_RING_CLASS,
        FORM_CONTROL_INVALID_CLASS,
        className,
        FORM_CONTROL_TEXT_CLASS,
        FORM_CONTROL_VALUE_CLASS,
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
